export const SendIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.74964 11.25L17.4996 2.50002M8.85596 11.5234L11.0461 17.1551C11.239 17.6512 11.3355 17.8993 11.4745 17.9717C11.595 18.0345 11.7385 18.0345 11.8591 17.9719C11.9982 17.8997 12.0949 17.6517 12.2884 17.1558L17.7804 3.08269C17.9551 2.63504 18.0424 2.41121 17.9946 2.26819C17.9532 2.14398 17.8557 2.04651 17.7315 2.00501C17.5885 1.95723 17.3646 2.04458 16.917 2.21927L2.84386 7.71122C2.34796 7.90474 2.10001 8.0015 2.02775 8.14059C1.96512 8.26116 1.9652 8.4047 2.02798 8.5252C2.1004 8.66421 2.34846 8.76067 2.84458 8.95361L8.47625 11.1437C8.57696 11.1829 8.62731 11.2024 8.66972 11.2327C8.7073 11.2595 8.74016 11.2924 8.76697 11.3299C8.79721 11.3723 8.8168 11.4227 8.85596 11.5234Z"
      stroke="#414651"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
